import React, { useEffect, useState } from "react"
import { DatabaseInvoiceData } from "./ReportDisplayTypes"
import { Table } from "react-bootstrap"
import "./ReportDisplay.css"


function InvoiceReportDisplay(props: {data: DatabaseInvoiceData[]}){
    const [data, setData] = useState<DatabaseInvoiceData[]>()
    useEffect(() => {
        setData(props.data)
    }, [props.data])
    return(
        <div className="ReportDisplayQB">
            <div className="ReportTableQB">
                {
                    props.data.length!==0?
                    <>
                        <div className="tableTitleQB">
                            <b>Database invoice Report</b>
                        </div>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Invoice Number</th>
                                    <th>Amount</th>
                                    <th>Date</th>
                                    <th>Is Paid</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data?.map((x, index) => (
                                        <tr key={index}>
                                            <td>{x.InvoiceNumber}</td>
                                            <td>{x.InvoiceAmount}</td>
                                            <td>{x.WeekEnding.split("T")[0]}</td>
                                            <td>{x.IsPaid ?? null}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </>
                    :null
                }
            </div>
        </div>
    )
}

export default InvoiceReportDisplay